function initChanges() {
  const categoryWraps = Array.from(document.querySelectorAll(".category-wrap"));
  categoryWraps.forEach((el) => {
    const button = el.querySelector(".category-button");
    if (button) {
      button.addEventListener("click", () => {
        el.classList.toggle("category-expanded");
      });
    }
  });

  const overviewButtons = Array.from(
    document.querySelectorAll(".overview-button")
  );
  overviewButtons.forEach((el, i) => {
    el.addEventListener("click", () => {
      categoryWraps[i].classList.add("category-expanded");
      categoryWraps[i].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });
  });

  const questionButtons = Array.from(
    document.querySelectorAll(".question-button")
  );
  questionButtons.forEach((el) => {
    el.addEventListener("click", () => {
      el.classList.toggle("question-expanded");
    });
  });

  if (window.location.hash) {
    const target = document.querySelector(window.location.hash);
    if (target) {
      target.classList.add("category-expanded");
    }
  }
}

$(initChanges);
